<template>
  <div class="address-selection" :class="{expanded: expanded && addresses.length > 1}">
    <ul v-if="addresses.length">
      <template v-for="(item, idx) in addresses">
        <li :key="item.id" v-if="expanded || item.id === selectedId" :class="{selected: item.id === selectedId}" @click="selectedId = item.id">
          <i class="zpc-iconchenggong" v-if="item.id === selectedId"></i>
          <div class="name">{{ item.name }}</div>
          <div class="addr">{{ item.province }}{{ item.city }}{{ item.area }}{{ item.details }}</div>
          <div class="tel">{{ item.phone }}</div>
          <div class="is-default" v-if="item.isdefault">默认</div>
          <div v-if="false" class="actions">
            <a href="javascript:" class="action-link" @click.stop="setDefault(item)" v-if="!item.isdefault">设为默认地址</a>
            <a href="javascript:" class="action-link" @click.stop="edit(item)">编辑</a>
            <a href="javascript:" class="action-link" @click.stop="remove(item, idx)">删除</a>
          </div>
        </li>
      </template>
    </ul>
    <div class="actions">
      <button href="javascript:" v-if="addresses.length > 1"
              @click="expanded = !expanded"
      >
        {{ expanded ? '收起地址' : '展示全部' }}
        <i class="zpc-iconjiantou1"></i>
      </button>
      <button @click="edit()"><i class="qpzs-icon-fangda"></i>新增收货地址</button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { ListReceiverAddress } from '../services'
export default {
  props: {
    user: {
      type: Object,
      default () {
        return {
          companyId: 0
        }
      }
    }
  },
  data () {
    return {
      addresses: [],
      selectedId: null,
      expanded: false
    }
  },
  computed: {
    companyId () {
      return this.user.companyId || 0
    }
  },
  created () {
    this.loadAddresses()
  },
  methods: {
    loadAddresses () {
      if (this.companyId) {
        ListReceiverAddress(this.companyId).then(data => {
          this.addresses = (data || []).filter(e => e.province && e.city && e.area && e.details)
        })
      }
    },
    edit (item) {
      if (!item && !(this.companyId)) {
        this.$message.error('请先选定平台用户')
        return
      }
      this.modal('AddressEditModal', item || null, this.user).promise.then(rst => {
        if (rst === true) {
          this.loadAddresses()
        }
      })
    },
    select (item) {
      this.selectedId = item.id
    },
    getAddressInfo () {
      let selectedItem = null
      if (this.addresses.length) {
        if (this.selectedId) {
          selectedItem = _.find(this.addresses, e => e.id === this.selectedId)
        }
        if (!selectedItem) {
          selectedItem = _.find(this.addresses, e => e.isdefault)
          if (!selectedItem) {
            selectedItem = this.addresses[0]
          }
          this.selectedId = selectedItem.id
        }
      } else {
        this.selectedId = null
      }
      return selectedItem
    }
  },
  watch: {
    user () {
      this.loadAddresses()
    },
    addresses: {
      immediate: true,
      handler () {
        // 用来刷新当前选中的地址
        this.$emit('select', this.getAddressInfo())
      }
    },
    selectedId: {
      immediate: true,
      handler () {
        this.expanded = false
        this.$emit('select', this.getAddressInfo())
      }
    }
  }
}
</script>
